import { FunctionComponent } from 'react'
import {
  Box,
  Skeleton,
  Typography,
  rucksack,
} from '@black-bear-energy/rucksack'

const MAX_MULTILINE_HEIGHT = '95px'

export const CardContentField: FunctionComponent<CardContentFieldProps> = ({
  label,
  value,
  isFetching,
  spanFullRow = false,
  isDisabled = false,
}) => {
  if (isFetching) {
    return <Skeleton width={100} />
  }
  return (
    <Box
      sx={{
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '5px',
        ...(spanFullRow ? { gridColumn: '1 / -1' } : {}),
        ...(isDisabled ? { color: rucksack.palette.text.disabled } : {}),
      }}
    >
      <Typography variant="subtitle2">{label}</Typography>
      <Typography
        variant="body1"
        sx={{
          color: rucksack.palette.text.secondary,
          whiteSpace: 'pre-line',
          overflowWrap: 'anywhere',
          alignSelf: 'stretch',
          maxHeight: MAX_MULTILINE_HEIGHT,
          overflowY: 'auto',
          ...(isDisabled ? { fontStyle: 'italic' } : {}),
        }}
      >
        {value ?? '—'}
      </Typography>
    </Box>
  )
}

export interface CardContentFieldProps {
  label: string
  value?: string | null
  isFetching: boolean
  spanFullRow?: boolean
  isDisabled?: boolean
}
